import React from 'react';
interface PhoneContainerProps {
  children: React.ReactNode;
}
export function PhoneContainer({
  children
}: PhoneContainerProps) {
  return <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4" data-id="element-120">
      <div className="w-full max-w-[430px] h-[932px] bg-white rounded-[3rem] shadow-2xl overflow-hidden relative border-[14px] border-gray-800" data-id="element-121">
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-7 bg-gray-800 rounded-b-3xl z-50" data-id="element-122"></div>
        <div className="w-full h-full overflow-y-auto" data-id="element-123">{children}</div>
      </div>
    </div>;
}